import { isSanityPathLink, isSanityRegistrationLink } from '../lib/sanity/link'
import { SanityMenuEntryProps } from './sanity/documents/menuEntry'

export function isAccountMenuEntry(menuEntry: SanityMenuEntryProps): boolean {
  const [firstTarget] = menuEntry?.link?.target || []
  return !!firstTarget && isSanityPathLink(firstTarget) && firstTarget.path === '/account'
}

export function isLoginMenuEntry(menuEntry: SanityMenuEntryProps): boolean {
  const [firstTarget] = menuEntry?.link?.target || []
  return !!firstTarget && isSanityPathLink(firstTarget) && firstTarget.path === '/login'
}

export function isRegistrationMenuEntry(menuEntry: SanityMenuEntryProps): boolean {
  const [firstTarget] = menuEntry?.link?.target || []
  return !!firstTarget && isSanityRegistrationLink(firstTarget)
}
